import React from 'react';
import { gradFor, initials } from '../hrComponents/hrAvatarUtils';

interface Props {
  user: { id?: number; first_name?: string; last_name?: string; avatarUrl?: string | null };
  baseUrl?: string;
  size?: number;
  fontSize?: number;
}

/**
 * Circular avatar with ring border.
 * Shows photo if avatarUrl is set, otherwise gradient initials.
 *
 * Photo wrapped in a div with overflow:hidden so objectFit:cover clips correctly.
 */
const UserAvatar: React.FC<Props> = ({ user, baseUrl = '', size = 36, fontSize }) => {
  const fs = fontSize ?? Math.round(size * 0.36);

  const containerStyle: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    flexShrink: 0,
    border: '2px solid var(--bg-form)',
    boxShadow: '0 0 0 1.5px rgba(0,0,0,0.10)',
    overflow: 'hidden',
  };

  if (user.avatarUrl) {
    return (
      <div style={containerStyle}>
        <img
          src={`${baseUrl}${user.avatarUrl}`}
          alt=""
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        ...containerStyle,
        background: `linear-gradient(135deg, ${gradFor(user.id ?? 0)})`,
        color: '#fff',
        fontSize: fs,
        fontWeight: 800,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        letterSpacing: '-0.5px',
      }}
    >
      {initials(user)}
    </div>
  );
};

export default UserAvatar;
